<div>
    <mat-drawer-container [hasBackdrop]="false" autosize style="height: calc(100vh - 50px); width:100%">
        <mat-drawer #drawer mode="side" opened style="display: block;">


            <div class="heading" > Locations</div>
            <div *ngIf=virtualFolders>
            <mat-nav-list>

                <!-- <mat-divider></mat-divider> -->
                <a *ngFor="let location of virtualFolders.listView" style="height: 30px;align-items: left;" mat-list-item
                    (click)="getLocation($event, location.value)">
                    <button mat-button style="font-size: 11pt; height: 30px; "
                        [ngStyle]="{'font-weight': location.value === selectedLocation ? 'bold' : 'normal' }">{{location.value}}</button>
                </a>
            </mat-nav-list>
        </div>
        </mat-drawer>
        <mat-drawer-content>

            <div class="container-fluid">
                <div *ngIf="!hideDocList">

                <div style="padding-left: 15px;padding-top: 5px;">
                <div class="card mt-1" style="width: 90%;" *ngIf=!selectedLocation>
                    <div class="card-body"><b>Please select a Location</b><br> 1. To view the sub-folders associated with it.</div>
                </div>
                </div>

            
            <div class="Tabletitle" *ngIf=selectedLocation>Virtual Folder Structure - MCRTX Cat
            </div>
            <div class="foldercontainer">
                <div *ngIf=folderElements>
                    <app-fileexplorer [folderElements]="folderElements | async" [selectedLocation]="selectedLocation"
                        [path]="currentPath" [level]="level" [canNavigateUp]="canNavigateUp" (navigatedDown)="navigateToFolder($event)" 
                        (displayFile)="getDocDetails($event,drawer)" (navigatedUp)="navigateUp()">
                    </app-fileexplorer>
                    <!-- <div *ngIf="loadNext" class="loadButton">
                        <button mat-raised-button (click)=next()>Next 1000<mat-icon>keyboard_arrow_right
                            </mat-icon></button>
                    </div>
                    <div *ngIf="loadPrevious" class="loadButton">
                        <button mat-raised-button (click)=previous()>
                            <mat-icon>keyboard_arrow_left</mat-icon>Previous 1000
                        </button>
                    </div> -->
                </div>
            </div>
        </div>

            <div class="col" *ngIf="selectedDoc && hideDocList">
                <!-- <app-filedetails [documentID]="documentId" (hideDocList)="onHideDocList($event)">
                </app-filedetails> -->
                <app-display-search-doc [selectedDocument]="selectedDoc" (hideDocList)="onHideDocList($event)"></app-display-search-doc>
            </div>
        </div>

        </mat-drawer-content>
    </mat-drawer-container>
</div>